<template>
    <div class="dataBox">
        <div class="baseTitle">设备信息</div>
        <div class="baseTop">
            <div class="baseBox" style="margin-right: 20px;">
                <div class="title">设备基础信息</div>
                <div class="baseData">
                    <div>设备电压：{{currentData.lowvoltage}}V</div>
                    <div>设备工作状态：
                        <span v-if="currentData.anomaly" class="yc">异常</span>
                        <span v-else class="zc">正常</span>
                    </div>
                    <div v-for="(item, index) in currentData.sensorInfoMap" :key="index">
                        {{item.cnName}}：{{item.sensorPhysicalValue}}{{ item.units }}
                    </div>
                    <div class="time">更新时间：{{ currentData.stamp }}</div>
                </div>
            </div>
            <div class="baseBox baseRight">
                <div class="title">当前监测文物</div>
                <div class="relicData">
                    <el-carousel :interval="4000" :autoplay="false" indicator-position="none" type="card" height="100%">
                        <el-carousel-item v-for="(item, index) in relicData" class="cssCarousel" :key="index">
                            <div class="relicBox">
                                <div class="relicImgBox" v-if="!item.relic||item.relic.relicPhotoList.length==0">
                                    暂无图片
                                </div>
                                <img class="relicImg" v-if="item.relic&&item.relic.relicPhotoList.length>0" :src="item.relic.relicPhotoList[0].path"/>
                                <div class="relicMsg" >
                                    名称：{{ item.relic?item.relic.name:item.name }}<br/>
                                    材质：{{ item.relic?item.relic.relicTexture.name:'-'}}<br/>
                                    年代：{{ item.relic?item.relic.relicEra.name:'-'}}<br/>
                                    等级：{{ item.relic?item.relic.relicLevel.name:'-' }}
                                </div>
                            </div> 
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
        </div>
        <div class="chartBox">
            <div class="title">历史数据统计</div>
            <div class="chart">
                <baseChart v-if="chartData.length>0" :data="chartData"/>
            </div>
        </div>
        
    </div>
</template>
<script>
import { realtimeData, historyData, relicList} from '@/api/device.js'
import baseChart from '@/components/chart/baseChart.vue'
import moment from 'moment';
export default{
    components:{
        baseChart
    },
    data(){
        return{
            locationId:37010201100515,
            currentData:{
                lowvoltage:null,
                anomaly:0,
                sensorInfoMap:[],
                stamp:null
            },
            chartData:[],
            relicData:[],
        }
    },
    mounted(){
        const urlParams = new URLSearchParams(window.location.search);
        if(urlParams.get('id')){
            this.locationId = urlParams.get('id');
        }
        this.getData()
    },
    methods:{
        moment,
        getData(){
            realtimeData(this.locationId).then(r=>{
                let data = r.data[0]
                this.currentData = {
                    lowvoltage:data.lowvoltage,
                    anomaly:data.anomaly,
                    sensorInfoMap:[],
                    stamp:moment(data.stamp).format('YYYY-MM-DD HH:mm:ss')
                }
                for(let key in data.sensorInfoMap){
                    this.currentData.sensorInfoMap.push(data.sensorInfoMap[key])
                }
            })
            let query = {
                locationId:this.locationId,
                startDate:moment().subtract(1, 'months').format('YYYY-MM-DD HH:mm:ss'),
                endDate:moment().format('YYYY-MM-DD HH:mm:ss'),
            }
            historyData(query).then(res=>{
                let listData = res.data
                if(listData.length==0){
                    return
                }
                let keys = Object.keys(listData[0].sensorInfoMap)

                this.chartData = keys.map(el=>{
                    let obj = {
                        name: '',
                        type: 'line',
                        smooth: true,
                        symbol: 'none',
                        data: []
                    }
                    obj['data'] = listData.map(i=>{
                        let data = i.sensorInfoMap[el]
                        obj['name'] = `${data.cnName}（${data.units}）`
                        return [i.stamp, data.sensorPhysicalValue]
                    })
                    return obj
                })
            })
            relicList(this.locationId).then(r=>{
                this.relicData = r.data.relicList
            })
        },
      
    }
}
</script>
<style lang="scss" scoped>
    .dataBox{
        width: 100%;
        min-height: 100%; 
        background-color: #000224;
        color: white;
        .title{
            font-size: 16px;
            height: 26px;
            line-height: 26px;
            font-weight: bold;
            color: white;
        }
        .baseTitle{
            width: 100%;
            background-image: url('../../assets/pageImg/titleLine.png');
            background-size: 100% 50%;
            background-position: 50% 80%;
            background-repeat: no-repeat;
            line-height: 30px;
            height: 50px;
        }
        .baseTop{
            width: 100%;
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            .baseBox{
                width: 300px;
                height:360px;
                font-size: 16px;
                font-size: 14px;
                overflow: hidden;
                margin-bottom: 20px;
                background-image: url('../../assets/pageImg/device-left.png');
                background-size: 100% 100%;
                background-repeat: no-repeat;
                padding: 5px 20px 10px 20px; 
                .baseData{
                    padding: 10px;
                    margin-right: 20px;
                    line-height: 30px;
                }
                .zc{
                    padding: 2px 5px;
                    background-color: green;
                    color: white;
                    font-size: 12px;
                }
                .yc{
                    padding: 2px 5px;
                    background-color: red;
                    color: white;
                    font-size: 12px;
                }
                .time{
                    font-size: 12px;
                }
            }
            .baseRight{
                width: 650px;
                height:360px;
                background-image: url('../../assets/pageImg/device-right.png');
                background-size: 100% 100%;
                background-repeat: no-repeat;
                padding: 5px 20px 10px 20px;
                .relicData{
                    width: 100%;
                    height: calc(100% - 50px);
                    .relicBox{
                        width: 180px;
                    }
                    .relicImg{
                        width: 100%;
                        height: 150px;
                        object-fit: contain;
                    }
                    .relicImgBox{
                        width: 100%;
                        height: 150px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        color: rgb(172, 172, 172);
                    }
                    .relicMsg{
                        line-height: 30px;
                    }
                }
            }
        }
        .chartBox{
            margin-top: 30px;
            padding: 10px 20px;
            width: 100%;;
            box-sizing: border-box;
            background-image: url('../../assets/pageImg/device-bot.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            .chart{
                width: 100%;
                height:360px;
            }
        }
    }
    
  /deep/.el-carousel--horizontal{
    height: 100%;
  }  
/deep/.cssCarousel{
    display: flex;
    justify-content: center;
    background-color: #000224;
}
</style>